export default __webpack_public_path__ + "static/media/discordo.c9bfe033.mpeg";